import styled from 'styled-components';
import Modal from 'react-modal';
import { withRouter } from 'react-router-dom';
import { useRecoilState, infoModalDataState } from '../../../store';
import BaseLayout from '@/components/ticketingNew/components/BaseLayout';
import OrderTicketFromTour from '@/components/ticketingNew/components/OrderTicketFromTour';

const StyledModal = styled<any>(Modal)`
  width: ${(props: any) => (props.mode !== EInfoModal.error ? '100%' : '746px')};
  height: ${(props: any) => (props.mode !== EInfoModal.error ? 'auto' : '421px')};
  max-width: 100%;

  .im-inner-wrap {
    background: rgba(79, 79, 79, 0.6);
    color: white;
    backdrop-filter: blur(150px);
    border-radius: 20px;
    padding: 54px 71px;
    text-align: center;

    .im-inner-warn {
      font-weight: 400;
      font-size: 60px;
      line-height: 90px;
      margin-bottom: 10px;
    }

    .im-inner-title {
      font-weight: 500;
      font-size: 22px;
      line-height: 33px;
      margin-bottom: 10px;
    }

    .im-inner-message {
      font-weight: 400;
      font-size: 15px;
      line-height: 22px;
      margin-bottom: 60px;
    }

    .im-inner-ok_btn {
      background-color: #ea475c;
      border-radius: 12px;
      color: white;
      font-weight: 600;
      font-size: 18px;
      padding: 15px 34px;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

      &:active {
        opacity: 0.8;
      }

      i {
        margin-left: 5px;
      }
    }
  }

  & > .cVideo-modal-videoWrap {
    width: 100%;
    height: 100%;

    & > iframe {
      width: 100%;
      height: 100%;
    }
  }

  .im-redirect-btn {
    margin-right: 15px;
  }
`;

export enum EInfoModal {
  error,
  timeIsUp,
  restrictedArea,
}

export interface IInfoModal {
  isOpen: boolean;
  mode?: EInfoModal;
  message?: string;
  redirectLink?: string;
  onRequestClose?: () => void;
  sweepThatCauseTicketRestriction?: any;
  reelThatCauseTicketRestriction?: any;
  ticketLoginData?: any;
}

const InfoModal = (props: any) => {
  const { root } = props;
  const [infoModalData, setInfoModalData] = useRecoilState(infoModalDataState);
  const handleClose = infoModalData.onRequestClose
    ? infoModalData.onRequestClose
    : () =>
        setInfoModalData({
          ...infoModalData,
          isOpen: false,
        });

  const handleCloseRedirect = () => {
    window.location.href = infoModalData?.redirectLink;
  };

  return (
    <StyledModal isOpen={infoModalData.isOpen} onRequestClose={handleClose} mode={infoModalData.mode} appElement={root}>
      {infoModalData.mode === EInfoModal.error && (
        <div className="im-inner-wrap">
          <div className="im-inner-warn">Oops!</div>
          <div className="im-inner-title">{infoModalData.message || 'Ticket not found'}</div>
          {!infoModalData.message && <div className="im-inner-message">You can find your customer code number on the purchase confirmation Email</div>}
          {infoModalData.redirectLink && (
            <button className="im-inner-ok_btn" onClick={handleCloseRedirect}>
              Proceed to needed page
            </button>
          )}
          <button className="im-inner-ok_btn" onClick={handleClose}>
            Got it <i className="fas fa-check" />
          </button>
        </div>
      )}
      {infoModalData.mode !== EInfoModal.error && (
        <BaseLayout transparentBg={true}>
          <div className="im-inner-wrap-order">
            <OrderTicketFromTour />
          </div>
        </BaseLayout>
      )}
    </StyledModal>
  );
};

export default withRouter(InfoModal);
